import useSharedStyles from '../shared.styles'

const useStyles = {
  ...useSharedStyles,
  helpLink: () => ({
    marginLeft: -1,
  }),
}

export default useStyles
